import { GRID_CELL_SIZE, MAX_SLIMES } from './constants';

export class SpatialHashGrid {
  readonly columns: number;
  readonly rows: number;
  readonly heads: Int16Array;
  readonly next = new Int16Array(MAX_SLIMES);
  constructor(width: number, height: number) {
    this.columns = Math.ceil(width / GRID_CELL_SIZE); this.rows = Math.ceil(height / GRID_CELL_SIZE);
    this.heads = new Int16Array(this.columns * this.rows); this.clear();
  }
  clear(): void { this.heads.fill(-1); this.next.fill(-1); }
  insert(id: number, x: number, y: number): void { const cell = this.cellIndex(x, y); this.next[id] = this.heads[cell]; this.heads[cell] = id; }
  forEachNearby(x: number, y: number, radius: number, visitor: (id: number) => void): void {
    const minX = Math.max(0, Math.floor((x - radius) / GRID_CELL_SIZE));
    const maxX = Math.min(this.columns - 1, Math.floor((x + radius) / GRID_CELL_SIZE));
    const minY = Math.max(0, Math.floor((y - radius) / GRID_CELL_SIZE));
    const maxY = Math.min(this.rows - 1, Math.floor((y + radius) / GRID_CELL_SIZE));
    for (let cellY = minY; cellY <= maxY; cellY += 1) for (let cellX = minX; cellX <= maxX; cellX += 1) {
      let id = this.heads[cellY * this.columns + cellX];
      while (id !== -1) { visitor(id); id = this.next[id]; }
    }
  }
  private cellIndex(x: number, y: number): number {
    const cellX = Math.max(0, Math.min(this.columns - 1, Math.floor(x / GRID_CELL_SIZE)));
    const cellY = Math.max(0, Math.min(this.rows - 1, Math.floor(y / GRID_CELL_SIZE)));
    return cellY * this.columns + cellX;
  }
}
